"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vue = require("@handsontable/vue");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _indexHotOpt = _interopRequireDefault(require("./components/indexHotOpt"));
var _userGuideApi = require("@/api/basicInfo/userGuideApi");
var _addUserInfo = _interopRequireDefault(require("./components/addUserInfo.vue"));
var _exportBtn = _interopRequireDefault(require("@/components/ExportBtn/exportBtn"));
var _utils = require("@/utils");
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    exportBtn: _exportBtn.default,
    HotColumn: _vue.HotColumn,
    HotTable: _vue.HotTable,
    Pagination: _Pagination.default,
    customRenderer: _indexHotOpt.default,
    addUserInfo: _addUserInfo.default
  },
  data: function data() {
    return {
      tableFilterColumn: {},
      disabledType: false,
      id: '',
      initDialogVisible: false,
      total: 0,
      tableData: [],
      loading: null,
      listQuery: {
        currentPage: 1,
        pageSize: 100
      },
      hotSettings: {
        dragCheck: true,
        height: 'calc(100vh - 215px)',
        width: '100%',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: false,
        fragmentSelection: 'cell',
        copyPaste: false
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {
    // this.$dictionary.get(['BIZ_EST_TYPE'], true).then((res) => {
    //   res = JSON.parse(JSON.stringify(res))
    //   this.estimateTypeList = res.BIZ_EST_TYPE ? res.BIZ_EST_TYPE : []
    // })
    this.handleSearch();
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.resizeHotTable();
      // this.tableData=[{vesselName:'vesselName'}]
    });
  },
  methods: {
    getTableData: function () {
      var _getTableData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(param) {
        var searchData, res, arr;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(param === 'currentPage')) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", this.tableData);
            case 4:
              if (!(param === 'selected')) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", this.$refs.hotTable.getSelections());
            case 8:
              if (!(param === 'all')) {
                _context.next = 17;
                break;
              }
              searchData = JSON.parse(JSON.stringify(this.listQuery));
              searchData.currentPage = 1;
              searchData.pageSize = 999999999;
              _context.next = 14;
              return (0, _userGuideApi.queryList)(searchData);
            case 14:
              res = _context.sent;
              arr = (0, _utils.deepClone)(res.data.records);
              return _context.abrupt("return", arr);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTableData(_x) {
        return _getTableData.apply(this, arguments);
      }
      return getTableData;
    }(),
    handleSearch: function handleSearch() {
      var _this2 = this;
      var data = {};
      data = this.listQuery;
      this.loading = (0, _utils.load)();
      (0, _userGuideApi.queryList)(data).then(function (res) {
        if (res.success) {
          _this2.tableData = res.data.records;
          _this2.total = res.data.totalRecord;
        }
      }).finally(function () {
        _this2.loading.close();
      });
    },
    handleAdd: function handleAdd() {
      this.id = '';
      this.initDialogVisible = true;
      this.disabledType = false;
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTable.resizeTo();
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    handleDouble: function handleDouble(_ref) {
      var physicalRow = _ref.physicalRow;
      this.handleEdit(physicalRow);
    },
    handleViewContract: function handleViewContract(row) {
      var data = this.$refs.hotTable.getSelected();
      this.id = data.id;
      this.disabledType = true;
      this.initDialogVisible = true;
    },
    handleEdit: function handleEdit(row) {
      var data = this.$refs.hotTable.getSelected();
      this.id = data.id;
      this.disabledType = false;
      this.initDialogVisible = true;
    },
    setInitDialogVisible: function setInitDialogVisible(val) {
      this.initDialogVisible = val;
    },
    columnRenderer: function columnRenderer(instance, td, row, col, prop, value, cellProperties) {
      Handsontable.renderers.TextRenderer.apply(this, arguments);
      if (value) {
        td.setAttribute('title', value);
        td.innerHTML = value;
      } else {
        td.innerHTML = "";
      }
    }
  }
};